<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <!--<li class="nav-item">-->
          <!--<router-link-->
            <!--:to="'/dashboard'"-->
            <!--class="nav-link"><i class="icon-speedometer"/> Рабочий стол</router-link>-->
        <!--</li>-->
        <li
          v-if="user.hasPermission('order.view.*')"
          class="nav-item">
          <router-link
            :to="'/orders'"
            class="nav-link"><i class="fa fa-list"/> Заказы</router-link>
        </li>
        <li
          v-if="user.isAdmin"
          class="nav-title">
          Админ центр
        </li>
        <li
          v-if="user.hasPermission('user.view.*')"
          class="nav-item">
          <router-link
            :to="'/admin/users'"
            class="nav-link"><i class="fa fa-users"/> Пользователи</router-link>
        </li>
        <li
          v-if="user.hasPermission('techcenter.view.*')"
          class="nav-item">
          <router-link
            :to="'/techcenters'"
            class="nav-link"><i class="fa fa-car"/> Техцентры</router-link>
        </li>
        <li
          v-if="user.hasPermission('city.view')"
          class="nav-item">
          <router-link
            :to="'/admin/cities'"
            class="nav-link"><i class="fa fa-map-marker"/> Города</router-link>
        </li>
        <li
          v-if="user.hasPermission('company.view.*')"
          class="nav-item">
          <router-link
            :to="'/admin/companies'"
            class="nav-link"><i class="fa fa-building"/> Компании</router-link>
        </li>
        <li
          v-if="user.hasPermission('role.view')"
          class="nav-item">
          <router-link
            :to="'/admin/roles'"
            class="nav-link"><i class="fa fa-lock"/> Роли</router-link>
        </li>
        <li
          v-if="user.hasPermission('pbx.listen.all')"
          class="nav-title">
          Телефония
        </li>
        <!--<li-->
          <!--v-if="user.hasPermission('pbx.listen.all')"-->
          <!--class="nav-item">-->
          <!--<router-link-->
            <!--:to="'/admin/pbx/incoming-calls'"-->
            <!--class="nav-link"><i class="fa fa-pie-chart"/> Статистика звонков</router-link>-->
        <!--</li>-->
        <li
          v-if="user.hasPermission('pbx.virtualNumbers.control')"
          class="nav-item">
          <router-link
            :to="'/admin/pbx/virtual-numbers'"
            class="nav-link"><i class="icon-call-out icons"/> Виртуальные номера</router-link>
        </li>
        <!--<li-->
          <!--v-if="user.hasPermission('pbx.internalNumbers.control')"-->
          <!--class="nav-item">-->
          <!--<router-link-->
            <!--:to="'/admin/pbx/internal-numbers'"-->
            <!--class="nav-link"><i class="icon-call-in icons"/> Внутренние номера</router-link>-->
        <!--</li>-->
        <li
          v-if="user.isAdmin"
          class="nav-item">
          <router-link
            :to="'/admin/custom-fields'"
            class="nav-link"><i class="fa fa-list-alt"/> Кастомные поля</router-link>
        </li>
        <li
          v-if="user.isAdmin"
          class="nav-item">
          <router-link
            :to="'/admin/statuses'"
            class="nav-link"><i class="fa fa-list-alt"/> Статусы</router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="'/help'"
            class="nav-link"><i class="fa fa-question"/> Помощь</router-link>
        </li>
        <transition name="fade">
          <li
            v-if="scrolled"
            class="nav-item scroll-to-top-btn">
            <a
              href="#"
              class="nav-link"
              style="width: 220px"
              @click.prevent="scrollToTopAction"><i class="fa fa-arrow-up"/> Наверх</a>
          </li>
          <li
            v-if="scrollToPrev && !scrolled"
            class="nav-item scroll-to-top-btn">
            <a
              href="#"
              class="nav-link"
              style="width: 220px"
              @click.prevent="scrollToPrevAction"><i class="fa fa-arrow-down"/> Вернуться</a>
          </li>
        </transition>
      </ul>
    </nav>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Sidebar',
    computed: {
      ...mapState({
        user: state => state.globalStore.user
      })
    },
    data () {
      return {
        scrolled: false,
        scrollToPrev: false
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        this.scrolled = window.scrollY > 1
        if (window.scrollY === 0) {
          this.scrollToPrev = false
        }
      },
      handleClick (e) {
        e.preventDefault()
        e.target.parentElement.classList.toggle('open')
      },
      scrollToTopAction () {
        this.scrollToPrev = window.scrollY
        this.$scrollTo('body', 500, {
          offset: 1
        })
      },
      scrollToPrevAction () {
        this.$scrollTo('body', 500, {
          offset: this.scrollToPrev
        })
      }
    }
  }
</script>

<style lang="css">
    .nav-link {
        cursor: pointer;
    }

    .sidebar .nav .nav-item.scroll-to-top-btn {
        position: fixed;
        bottom: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s
    }

    .fade-enter, .fade-leave-to {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?2ff65398